import styled, { css } from "styled-components";
import { Registry } from "@diana-ui/registry";
export var StyledBaseTextInput = /*#__PURE__*/ styled(Registry.get("TextInput")).withConfig({
  displayName: "ErrorTextInputstyle__StyledBaseTextInput"
})([""]);
/**
 * Component wrapper
 */

export var ErrorTextInputWrapper = /*#__PURE__*/ styled.div.withConfig({
  displayName: "ErrorTextInputstyle__ErrorTextInputWrapper"
})([""]);
export var HelperLabel = /*#__PURE__*/ styled.div.withConfig({
  displayName: "ErrorTextInputstyle__HelperLabel"
})(_ref => {
  var { theme } = _ref;
  return css(
    ["display:flex;flex-direction:column;align-items:flex-end;", ";"],
    theme.typography.label
  );
});
export var TypedLabel = /*#__PURE__*/ styled.span.withConfig({
  displayName: "ErrorTextInputstyle__TypedLabel"
})(_ref2 => {
  var { theme, error, hint } = _ref2;
  return css(
    ["", " ", ""],
    error && css(["color:", ";"], theme.colors.alert.alert100),
    hint && css(["color:", ";"], theme.colors.black)
  );
});
